<script setup lang="ts">
import { computed } from 'vue'

import CalendarPicker from '@tix/ds/components/organisms/calendar/CalendarPicker.vue'
import { calendarDatesIndex, getMonths } from '@tix/ds/components/organisms/calendar/helpers.ts'
import type { DayData } from '@tix/ds/components/organisms/calendar/types.ts'

import { apiDatesToDayData } from './calendarTransform'

export type CalendarPickerContentProps = {
  dates: { date?: string; status?: string }[]
  timezone: string
  onSelect: (date: string) => void
}

const props = defineProps<CalendarPickerContentProps>()

const index = computed(() => {
  const dayData = apiDatesToDayData(props.dates, props.timezone)
  return calendarDatesIndex(dayData)
})

const months = computed(() => getMonths(index.value))

function handleSelect(day: DayData): void {
  props.onSelect(day.date.date)
}
</script>

<template>
  <CalendarPicker
    :capacityThreshold="false"
    :displayPrices="false"
    :index="index"
    :months="months"
    :showLegend="true"
    @select="handleSelect"
  />
</template>
